import styled from "styled-components";
import Logo from "../../images/PMB_sign_logo.png";
import { respondTo } from "../../styles";

export const AccountSection = styled.section`
  display: none;
  background-color: var(--accountBg);
  overflow: hidden;

  ${respondTo.lg`
    display: block;  
  `}

  @media print {
    display: block;
    background-color: white;
  }

  h2 {
    font-size: 40px;
    color: var(--creamWhite);
  }
`;

export const AccountSectionLogo = styled.div`
  background-image: url(${Logo});
  background-repeat: no-repeat;
  background-size: contain;
  height: 127px;
  width: 293px;
  margin: 0 auto 50px;
`;

export const AccountScreenWidthInfo = styled(AccountSection)`
  display: block;

  ${respondTo.lg`
    display: none;  
  `}

  @media print {
    display: none;
  }
`;
